import React from "react";

const CallButton = () => {
  return (
    <div
      className="fixed bottom-6 left-4 bg-gradient-to-r from-blue-800 to-blue-400 shadow-lg p-2 rounded-lg border border-blue-500"
      style={{ zIndex: 10000 }}
    >
      {/* Icon Điện Thoại */}
      <a href="tel:0935255096" className="flex items-center gap-1 lg:gap-2">
        <img
          src={
            "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227183/call_eddcbw.gif"
          }
          alt="Call"
          className="w-6 h-6 lg:w-10 lg:h-10 object-contain"
        />
        {/* Số điện thoại */}
        <div className="flex flex-col gap-0.5 lg:gap-1">
          <span className="text-xs lg:text-base text-cyan-400 font-bold">
            Gọi để được tư vấn
          </span>
          <span className="text-white font-semibold text-sm hover:text-blue-600">
            0935 255 096
          </span>
        </div>
      </a>
    </div>
  );
};

export default CallButton;
